import { FC, Fragment } from "react"
import { ItemInput } from "../../../../../../../../_webui/layout/components/Form/Item/Input"
import { Translate } from "../../../../../../../../constant/Translate"
import { validatorHalfSizeProjectName } from "../../../../../../../../utils/validator/halfSize"
import { ItemSelect } from "../../../../../../../../_webui/layout/components/Form/Item/Select"
import { SchedulesAddAssignmentProps } from "./models"

const {
  HELP_H0038,
  MESSAGE_E0001,
  TEXT_T199,
  TEXT_T200,
  TEXT_T219,
  TEXT_T236,
  TEXT_T712,
} = Translate

export const SchedulesAddAssignment: FC<SchedulesAddAssignmentProps> = ({
  locationToSendMailList,
}) => {
  return (
    <Fragment>
      <ItemInput label={TEXT_T199} maxLength={200} name="projectNameJp" />

      <ItemInput
        label={TEXT_T200}
        maxLength={200}
        name="projectNameEn"
        rules={[validatorHalfSizeProjectName]}
      />

      <ItemSelect
        isDefaultValue={false}
        label={TEXT_T219}
        name="locationToSendMail"
        required
        rules={[
          {
            validator(_, value: string | null) {
              if (value === null || typeof value === "undefined") {
                return Promise.reject(new Error(MESSAGE_E0001))
              }
              return Promise.resolve()
            },
          },
        ]}
        selectItem={[{ text: TEXT_T712, value: "" }, ...locationToSendMailList]}
        tooltip={HELP_H0038}
      />

      <ItemInput label={TEXT_T236} maxLength={100} name="locationPersonName" />
    </Fragment>
  )
}
